import { post } from '../../utils/http';

export const createMainProjectAcrossBranches = ({
  accountId,
  name,
  startDate,
  endDate,
  color,
  startTime,
  doorTime,
  identifier,
  glCode,
  estimatedAttendance,
  expectedRevenue,
  totalActualRevenue,
  actualAttendance,
  metadata,
  branches,
  createChildProjects
}) =>
  post(`/accounts/${accountId}/main-projects`, {
    name,
    startDate,
    endDate,
    color,
    startTime,
    doorTime,
    identifier,
    glCode,
    estimatedAttendance,
    expectedRevenue,
    totalActualRevenue,
    actualAttendance,
    metadata,
    branches,
    createChildProjects
  });
